<template>
    <list-page icone="mdi mdi-chart-bar-stacked" titulo="Previsão Orçamentária" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>
            <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
                <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                    </v-tooltip>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-icon small @click="Detalhar(item)" v-on="on">mdi-file</v-icon>
                        </template>
                        <span>Detalhar</span>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.despesa`]="{ item }">
                    {{ item.despesa ? 'Despesa' : 'Receita' }}
                </template>

            </v-data-table>

        <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <cadastro-orcamento v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>

<script>
import OrcamentoService from '../../../core/services/financeiro/OrcamentoService';
import { Orcamento } from '../../../core/domain/financeiro/Orcamento';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
        headers: [
            { text: '', value:'actions', sortable: false  },
            { text: 'Ano', value: 'ano', type: 'number' },
            { text: 'Tipo', value: 'despesa', type: 'boolean' }
        ],
        primeiraCarga: true
    }),
    created() {
        this.service = new OrcamentoService();
    },
    watch:{
        lista: function(){
            if(this.primeiraCarga)
                this.primeiraCarga = false;
        }
    },
    methods: {
        Novo(){
            this.NovoCadastro(new Orcamento());
        },
        Editar(item){
            this.primeiraCarga = true;
            this.service.ObterPorId(item.id, "PlanoContas.PlanoConta, PlanoContas.PlanoContaItem").then(
                res =>{
                    this.EditarCadastro(new Orcamento(res.data));
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            ).finally(() => {
                this.primeiraCarga = false;
            })
        },
        Detalhar(item){
            let routeLink = this.$router.resolve({ name: 'relatorioOrcamento', params: { id: item.id.toString() } });
            window.open(routeLink.href, '_blank');
        },
    },
    mounted() {
        this.Listar(null)
    }
}
</script>
<style scoped>

</style>
